import { Form, Input, Modal, Select } from 'antd';
import cx from 'classnames';
import 'moment-timezone';
import moment from 'moment-timezone';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Button from '../../components/Button/Button';
import { useRequestContext } from './Request.Provider';
import { ValidatedFormItem } from './RequestComments';

moment.tz.setDefault('Europe/Kiev');

const { Option } = Select;

const startRequestTime = parseInt(process.env.REACT_APP_START_REQUEST_TIME);

const endRequestTime = parseInt(process.env.REACT_APP_END_REQUEST_TIME);

const RequestCreate = () => {
  const {
    form,
    formContent,
    formContentItem,
    clickedSubmit,
    handleClickForm,
    onValuesFormChange,
    references,
    formUpdate,
    successModal,
    setSuccessModal,
  } = useRequestContext();

  const location = useHistory();
  const [currentCategoryValue, setCurrentCategoryValue] = useState(
    location.location.search.slice(1)
  );
  const [isWorkTime, setIsWorkTime] = useState(true);
  const [timeLeft, setTimeLeft] = useState('');
  const [currentServiceCat, setCurrentServiceCat] = useState('');

  const selectCategoryValue = currentCategoryValue
    ? references.Category?.find((item) => item.Id === currentCategoryValue)?.Name
    : 'Обрати';

  useEffect(() => {
    if (references.Category && currentCategoryValue) {
      form.setFieldsValue({
        Category: currentCategoryValue,
      });
    }
  }, [references.Category, form, currentCategoryValue]);

  useEffect(() => {
    const checkWorkTime = () => {
      const now = moment();
      const day = now.day(); // 0 - неділя, 6 - субота
      const hour = now.hour();

      // Робочий час: понеділок - п'ятниця, 9:00 - 16:00
      const isWorkDay = day >= 1 && day <= 5;
      const isWorkHour = hour >= startRequestTime && hour < endRequestTime;

      // Исключение для категории "звернення на роботи" - доступна в выходные, но в рабочие часы
      const isMaintenanceCategory = currentCategoryValue === 'f8b0f38b-60fd-42d9-b87d-39e704ed6d27';
      const isWeekend = day === 0 || day === 6; // суббота или воскресенье

      if ((isWorkDay && isWorkHour) || (isMaintenanceCategory && isWeekend && isWorkHour)) {
        setIsWorkTime(true);
      } else {
        setIsWorkTime(false);
        calculateTimeLeft();
      }
    };

    const calculateTimeLeft = () => {
      const now = moment();
      let nextWorkTime;

      if (now.day() === 6) {
        // Субота: наступний робочий день - понеділок startRequestTime:00
        nextWorkTime = moment().day(8).startOf('day').hour(startRequestTime); // Наступний понеділок
      } else if (now.day() === 0) {
        // Неділя: наступний робочий день - понеділок startRequestTime:00
        nextWorkTime = moment().day(1).startOf('day').hour(startRequestTime); // Наступний понеділок
      } else if (now.hour() >= endRequestTime) {
        // Після робочого часу: наступний робочий день startRequestTime:00
        nextWorkTime = moment().add(1, 'days').startOf('day').hour(startRequestTime);
      } else {
        // До робочого часу: сьогодні startRequestTime:00
        nextWorkTime = moment().startOf('day').hour(startRequestTime);
      }

      const duration = moment.duration(nextWorkTime.diff(now));
      const hours = Math.floor(duration.asHours());
      const minutes = Math.floor(duration.asMinutes()) % 60;
      setTimeLeft(`${hours} год ${minutes} хв`);
    };

    checkWorkTime();
    const interval = setInterval(() => {
      checkWorkTime();
    }, 60000); // Оновлювати кожну хвилину

    return () => clearInterval(interval);
  }, [currentCategoryValue]); // Добавляем currentCategoryValue в зависимости

  const handleCategoryRequest = (e) => {
    setCurrentCategoryValue(e);
  };
  useEffect(() => {
    if (successModal) {
      setTimeout(() => {
        setSuccessModal(false);
        location.push('/');
      }, 3000);
    }
  }, [successModal, location, setSuccessModal]);

  // Effect to update currentServiceCat when the service category changes
  useEffect(() => {
    const serviceCategory = form.getFieldValue('ServiceCategory');
    if (serviceCategory !== currentServiceCat) {
      setCurrentServiceCat(serviceCategory);
    }
  }, [form, currentServiceCat, formUpdate]);

  return (
    <div className="request-page-create boxes" style={{ flexDirection: 'column' }}>
      <div className="box create-request">
        {isWorkTime ? (
          <>
            <div className="text-black-medium-f22-l30">Створення звернення</div>
            <div className="text-grey-dark-normal-f16-l28">
              Будь ласка, заповніть усі необхідні дані для створення звернення.
            </div>
            <div className="create-request__container field-grey-straight-border">
              {' '}
              <Form
                onValuesChange={(changedValues) => {
                  onValuesFormChange(changedValues);
                  // Update currentServiceCat when ServiceCategory changes
                  if (changedValues.ServiceCategory) {
                    setCurrentServiceCat(changedValues.ServiceCategory);
                  }
                }}
                form={form}
                validateTrigger={['onChange', 'onSubmit']}
                className={cx('create-request__form', { disabled: clickedSubmit })}
              >
                <div className="create-request__col">
                  {' '}
                  <Form.Item
                    name="Category"
                    label="Категорія звернення"
                    validateTrigger={['onChange', 'onSubmit']}
                    rules={[{ required: true, message: 'Оберіть категорію звернення' }]}
                  >
                    <Select
                      onChange={handleCategoryRequest}
                      loading={!references.Category?.length}
                      disabled={clickedSubmit || location.location.search.slice(1).length > 0}
                      placeholder={selectCategoryValue}
                    >
                      {references.Category?.filter(({ Id }) =>
                        [
                          '2a92dbea-2b8c-4a63-b3f6-ea4135f981d7', // СКД картка
                          'f8b0f38b-60fd-42d9-b87d-39e704ed6d27', // звернення на роботи
                          'd7982047-eef2-435d-bf58-758c818433e4', // звернення до адміністрації
                        ].includes(Id)
                      ).map(({ Id, Name }) => (
                        <Option key={Id} value={Id}>
                          {Name}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>{' '}
                  <Form.Item
                    name="Subject"
                    label="Тема звернення"
                    validateTrigger={['onChange', 'onSubmit']}
                    rules={[{ required: true, message: 'Опишіть тему звернення' }]}
                  >
                    <Input placeholder="Опишіть тему звернення" disabled={clickedSubmit} autoFocus />
                  </Form.Item>
                  {/* Display SuWorkDescription field only when it would be displayed in normal form content */}{' '}
                  {currentCategoryValue && currentServiceCat && (
                    <ValidatedFormItem
                      name="SuWorkDescription"
                      label={
                        currentServiceCat === '88a699c2-b2de-4bde-9ffd-c038a9a174f9'
                          ? 'Мета візиту'
                          : 'Опис робіт'
                      }
                      placeholder={
                        currentServiceCat === '88a699c2-b2de-4bde-9ffd-c038a9a174f9'
                          ? 'Вкажіть мету візиту'
                          : 'Опишіть роботи, які плануються'
                      }
                      errorMessage={
                        currentServiceCat === '88a699c2-b2de-4bde-9ffd-c038a9a174f9'
                          ? 'Вкажіть мету візиту'
                          : 'Опишіть роботи, які плануються'
                      }
                      required={true}
                      disabled={clickedSubmit}
                      inputType="input"
                      validateTrigger={['onChange', 'onSubmit']}
                    />
                  )}

                </div>
                <div className="create-request__col">
                  {currentCategoryValue && (
                    <>
                      {formContent[currentCategoryValue]}
                      {formContentItem.Agreement}
                      <Form.Item>
                        <Button
                          style={{ width: '100%' }}
                          onClick={handleClickForm}
                          type="submit"
                          text="Надіслати"
                          bg="pink"
                          disabled={clickedSubmit}
                        />
                      </Form.Item>
                    </>
                  )}
                </div>
              </Form>
            </div>
          </>
        ) : (
          <div className="non-work-time-message">
            <div className="text-black-medium-f22-l30">Створення звернень заблоковано</div>
            <div className="text-grey-dark-normal-f16-l28">
              Подання звернень наразі недоступне.
              <br /> Ми приймаємо їх у{' '}
              <span className="text-black-normal-f16-l28">
                будні з {startRequestTime}:00 до {endRequestTime}:00
              </span>
              .
            </div>
            <div className="text-grey-dark-normal-f16-l28">
              Спробуйте, будь ласка, через{' '}
              <span className="text-black-normal-f16-l28">{timeLeft}</span>.
            </div>
          </div>
        )}

        <Modal
          className="success-modal"
          visible={successModal}
          footer={null}
          onCancel={() => setSuccessModal(false)}
        >
          <div className="success-modal__wrapper">
            <div className="text-black-medium-f22-l30">Дякуємо</div>
            <div className="text-grey-dark-normal-f16-l28">
              Ми прийняли ваше звернення та зв'яжемося
              <br /> з вами найближчим часом
            </div>
          </div>
        </Modal>
      </div>
    </div>
  );
};

export default RequestCreate;
